module.exports = __webpack_public_path__ + "static/media/Position_3m.b01c8401.jpg";